import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { Meta } from '../../angular2-meta';
import { IAppState } from '../app.state';
import { Config } from '../universal-config';
import { toggleOutlines } from '../visual/visual.actions';

@Component({
  selector: 'nns-share-note',
  template: `
    <nns-exit-fullscreen
      *ngIf="visual.isFullscreen"
      ></nns-exit-fullscreen>
    <nns-top flex="none"
      *ngIf="showTopActions"
      [note]="note"
      [attachments]="attachments"
      [visual]="visual"
      [login]="login"
      [shareCopy]="shareCopy"
      [share]="share"
      [branding]="branding"
      [profile]="profile"
      [ngClass]="{
        'nns-fullscreen': visual.isFullscreen,
        'nns-top-fixed': visual.isHeaderFixed,
        'nns-top-empty': !share.parent && (branding && !branding.sharesShowDate && !branding.sharesFullscreen && !branding.sharesShareButton && !branding.sharesAllowPrint),
        'nns-top-align-left': showShareConfig || isShowOutlines
      }"
    ></nns-top>
    <div class="wrapper"
      [ngClass]="{'nns-no-sidebar': !showShareConfig && !isShowOutlines,
                  'nns-sidebar-has-config': showShareConfig && !isShowOutlines}">
      <nns-tabs
        *ngIf="attachmentsInListCount"
        class="mobile"
        flex="none"
        [filesCount]="attachmentsInListCount"
        [todosCount]="todosCount"
        (changeTab)="changeTab($event)"
      ></nns-tabs>
      <nns-note
        [profile]="profile"
        [note]="note"
        [text]="text"
        [attachments]="attachments"
        [todos]="todos"
        [share]="share"
        [visual]="visual"
        [ngClass]="{'nns-fullscreen': visual.isFullscreen}"
        [activeTab]="activeTab"
        [branding]="branding"
        [showShareConfig]="showShareConfig"
        [isShowOutlinesBtn]="isShowOutlinesBtn"
        [outlinesButtonTitle]="outlinesButtonTitle"
      ></nns-note>
      <div
        class="nns-sidebar">
        <nns-share-config
          *ngIf="showShareConfig"
          [note]="note"
          [share]="share"
          [workspaces]="workspaces"
          [currentNoteWorkspace]="currentNoteWorkspace"
          [visual]="visual"
          [profile]="profile"
        ></nns-share-config>
        <div
          id="nns-outline-wrapper"
          *ngIf="isShowOutlines">
        <nns-outline
          [isSingle]="!showShareConfig"
          [isFullScreen]="visual.isFullscreen"
          [outlines]="outlines">
        </nns-outline>
        </div>
      </div>
    </div>
    <nns-spam
      *ngIf="!visual.isEmbed && !visual.isPreview && !share.instance.orgTitle"
      flex="none" layout="row" layout-align="start start"
    ></nns-spam>
    <nns-to-top flex layout="row" layout-align="center center"
      *ngIf="visual.isShowToTopComponent && !visual.isEmbed"
    ></nns-to-top>
    <nns-todos-panel
      [todos]="todos"
      [todosOrder]="note.todosOrder"
      [ngClass]="{'nns-full-screen': visual.isFullscreen}"
      *ngIf="visual.isTodoPanelOpened && todos && todos.length"
    ></nns-todos-panel>
  `,
  styles: [`
    nns-top {
      position:relative;
      left:0;
      top:0;
    }
    .wrapper{
      flex: 1;
      display: flex;
    }
    .wrapper:not(.nns-no-sidebar){
      display: flex;
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      padding-left: 230px;
    }
    nns-note{
      width: 100%;
    }
    .nns-sidebar{
      flex: 0 0 230px;
      width: 230px;
      background-color: #fff;
    }
    .nns-no-sidebar .nns-sidebar{
      display: none;
    }
    .nns-no-sidebar .wrapper{
      padding-left: 0;
    }

    nns-share-config{
      display: block;
      margin-top: 41px;
    }

    nns-outline-btn{
      position: absolute;
      right: 12px;
      top: 41px;
    }

    @media only screen and (min-width: 1200px) {
      .wrapper:not(.nns-no-sidebar) nns-note {
        max-width: calc(100% - 230px);
      }
    }

    @media only screen and (max-width: 1430px) {
      .wrapper{
        padding-left: 0!important;
      }
    }

    @media only screen and (max-width: 1200px) {
      .nns-sidebar{
        position: fixed;
        right: 0;
        top: 57px;
        height: 100%;
      }

      .nns-no-sidebar .nns-sidebar{
        right: -300px;
      }

      .nns-sidebar-has-config .nns-sidebar {
        right: -300px;
      }

      .wrapper:not(.nns-no-sidebar) nns-note{
        max-width: 100%;
      }

      .wrapper:not(.nns-no-sidebar) nns-note ::ng-deep .editor-body{
        padding: 0 10px;
      }

      .nns-sidebar nns-share-config {
        display: none;
      }
    }

    @media only screen and (max-width: 768px) {
      nns-exit-fullscreen{
        display: none;
      }
    }

    @media only screen and (max-width: 600px) {
      .wrapper{
        flex-direction: column;
      }
    }
  `, `
    :host-context(.no-flex) nns-note {
      display:block;
    }
    :host-context(.nns-theme-night) .nns-sidebar{
      background-color: #20252B;
    }
    :host-context(.nns-fullwidth) .wrapper{
      box-sizing: border-box;
      margin: 0;
      padding-left: 0;
      max-width: 100%;
    }
  `]
})
export class ShareNoteComponent implements OnInit, OnChanges {
  @Input() note;
  @Input() parent;
  @Input() text;
  @Input() login;
  @Input() attachments;
  @Input() workspaces;
  @Input() currentNoteWorkspace;
  @Input() todos;
  @Input() share;
  @Input() visual;
  @Input() shareCopy;
  @Input() preview;
  @Input() branding;
  @Input() profile;
  @Input() outlines;

  attachmentsInListCount = 0;
  todosCount = 0;
  showShareConfig: boolean = false;
  isShowOutlines: boolean = false;
  isShowOutlinesBtn: boolean = false;
  outlinesButtonTitle: string;

  activeTab = 1;
  eventSubscription

  showTopActions: boolean;

  constructor(
    public _meta: Meta,
    public _config: Config,
    public _store: Store<IAppState>,
  ) {}

  ngOnInit() {
    if(window.innerWidth <= 1200) {
      this._store.dispatch(toggleOutlines());
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.attachments) {
      this.attachmentsInListCount = this.attachments.filter((item) => item.inList).length;
    }
    if (changes.todos) {
      this.todosCount = this.todos.filter((item) => !item.checked).length;
    }
    if (changes.share || changes.visual || changes.note || changes.profile || changes.workspaces) {
      if(this.share && this.share.instance && this.share.instance.currentUserCanEdit
          && !this.visual.isEmbed && !this.visual.isMobile && !this.visual.isFullWidth
          && this.note
          && this.profile
        ) {
        const isSuitableRole =
          this.note.role == 'screencast'
          || this.note.role == 'video'
          || this.note.role == 'streaming_video'
          || this.note.role == 'screenshot'
          || this.note.role == 'clip';

        const showShareConfig = this.share.instance.currentUserCanEdit && isSuitableRole && this.workspaces && this.workspaces.length;
        this.showShareConfig = showShareConfig;
      } else {
        this.showShareConfig = false;
      }
    }
    if (changes.visual || changes.note) {
      this.isShowOutlines = this.visual.isShowOutlines && this.branding.sharesOutliner && this.outlines && this.outlines.length && !this.visual.isEmbed && this.note.outliner;
      if(this.isShowOutlines) {
        this.outlinesButtonTitle = 'Hide table of contents';
      } else {
        this.outlinesButtonTitle = 'Show table of contents';
      }
    }
    if (changes.outlines || changes.branding || changes.visual) {
      this.isShowOutlinesBtn = this.outlines && !!this.outlines.length && this.branding.sharesOutliner && !this.visual.isEmbed && this.note.outliner;
    }
    this.setMeta();
    this.showTopActions =
      !this.visual.isEmbed
      || (this.visual.isEmbed && this.share.parent && !this.visual.isVideo && this.note.role != 'screenshot' && !this.visual.isWordpress)
      || (this.visual.isEmbed && this.visual.isEmbedPrintEnabled)
  }

  setMeta() {
    let brandingSMMImage = null;
    if(this.share && this.share.instance && this.share.instance.brandingProfile && this.share.instance.brandingProfile.sharesSMMImageStoredFileUUID) {
      brandingSMMImage = {
        type: 'image',
        mime: 'image/png',
        attachmentURL:  `/file/${this.share.instance.brandingProfile.sharesSMMImageStoredFileUUID}`,
      }
    }
    const attachment = this.preview || brandingSMMImage || this._meta.getOrgLogoImage(this.share) || null;
    this._meta.setMetaForNode(this.share, this.note, this.text, attachment);
  }

  changeTab(event) {
    this.activeTab = event;
  }
}
